module.exports = __webpack_public_path__ + "img/kplay_esport.3d5d3bd9.jpg";